import { useSelector } from "react-redux";

import { FreezeOnExit } from "@src/components/animation/FreezeOnExit";
import { BannerComponentPanel } from "@src/features/experienceBuilder/modifications/components/BannerComponentPanel";
import { ComponentSelectionPanel } from "@src/features/experienceBuilder/modifications/components/ComponentSelectionPanel";
import { GenericComponentPanel } from "@src/features/experienceBuilder/modifications/components/GenericComponentPanel";
import { ImageComponentPanel } from "@src/features/experienceBuilder/modifications/components/ImageComponentPanel";
import { OnsiteUpsellComponentPanel } from "@src/features/experienceBuilder/modifications/components/OnsiteUpsellComponentPanel";
import { TextComponentPanel } from "@src/features/experienceBuilder/modifications/components/TextComponentPanel";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

export function useComponentPanels() {
  const insertContext = useSelector(
    ExperienceBuilderSelector.component.getInsertContext
  );
  const draft = useSelector(
    ExperienceBuilderSelector.component.getVariationDraft
  );

  return [
    insertContext && (
      <FreezeOnExit key="component-selection">
        <ComponentSelectionPanel />
      </FreezeOnExit>
    ),
    draft && (
      <FreezeOnExit key="component-editor">
        {draft.type === "bannerComponent" && <BannerComponentPanel />}
        {draft.type === "textComponent" && <TextComponentPanel />}
        {draft.type === "imageComponent" && <ImageComponentPanel />}
        {draft.type === "genericComponent" && <GenericComponentPanel />}
        {draft.type === "onsiteUpsell" && <OnsiteUpsellComponentPanel />}
      </FreezeOnExit>
    ),
  ];
}
